$( document ).ready(function() {
  const forms = document.querySelectorAll('form[data-variants]');
  if (!forms.length) return;

  forms.forEach(function(form) {
    const variantIds = JSON.parse(form.dataset.variants);
    const variantOptions = JSON.parse(form.dataset.options);
    const variantAvailability = JSON.parse(form.dataset.availability);
    const addToCartBtn = form.querySelector('.add-to-cart');

    function updateVariantId() {
      const selectedOptions = [];
      // Obtener todos los radios seleccionados
      const checkedRadios = form.querySelectorAll('input[type=radio]:checked');
      checkedRadios.forEach((radio) => {
        selectedOptions.push(radio.value.trim());
      });
      // Obtener todos los selects
      const selects = form.querySelectorAll('select');
      selects.forEach((select) => {
        selectedOptions.push(select.value.trim());
      });
      const matchingVariantIndex = variantOptions.findIndex((variantOpts) => {
        return variantOpts.every((opt, i) => opt === selectedOptions[i]);
      });
      if (matchingVariantIndex !== -1) {
        const variantId = variantIds[matchingVariantIndex];
        const variantInput = form.querySelector('.product-variant-id');
        if (variantInput) {
          variantInput.value = variantId;
        }
        if (addToCartBtn) {
          if (!variantAvailability[variantId]) {
            addToCartBtn.classList.add('sold-out');
            addToCartBtn.textContent = 'Sold out';
          } else {
            addToCartBtn.classList.remove('sold-out');
            addToCartBtn.textContent = 'Add to cart';
          }
        }
      } else {
        console.warn('No matching variant for:', selectedOptions);
      }
    }

    form.addEventListener('change', function (e) {
      if (
        e.target.matches('input[type=radio]') ||
        e.target.matches('select')
      ) {
        updateVariantId();
      }
    });

    updateVariantId();
  });
});